import React from "react"
import { Content } from "../content/Content"
import { graphql } from "gatsby"
import "./cta-banner.module.scss"
import { Button as IButton } from "_types/Button"
import { ImageBuilder } from "_types/AssetsImage"
import { RichTextContent } from "_types/RichText"
import { ButtonParser } from "components/button/ButtonParser"
import { getBackgroundImageUrlByBreakpoint } from "assets/helper/getBackgroundImageUrlByBreakpoint"

interface CTABannerProps {
  background?: ImageBuilder
  heading: string
  buttons: IButton
  description?: string
  eyebrow_text?: string
}

export const CTABanner = ({
  background,
  heading,
  description,
  eyebrow_text,
  buttons,
}: CTABannerProps) => {
  const backgroundImageCSSVariable = background?.url
    ? getBackgroundImageUrlByBreakpoint({
        variableName: "cta-banner-background-image",
        imageUrl: background.url,
      })
    : {}

  return (
    <section className={`fr-cta-banner`} style={backgroundImageCSSVariable}>
      <div className={`fr-container`}>
        <div className="fr-cta-banner__wrapper">
          {heading && (
            <div
              className={`u-container-header u-text--align-center fr-cta-banner__heading`}
            >
              {eyebrow_text && <h3 className="eyebrow_text">{eyebrow_text}</h3>}
              {heading && <h2>{heading}</h2>}
            </div>
          )}
          {description && (
            <p className="fr-cta-banner__description">{description}</p>
          )}

          {buttons.value?.length > 0 && (
            <div
              className={`u-buttons-group fr-cta-banner__button-container ${
                !description
                  ? `fr-cta-banner__button-container--no-description`
                  : ""
              }`}
            >
              <ButtonParser
                extraClassNames={"fr-cta-banner__button"}
                buttons={buttons.value}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export const query = graphql`
  fragment CTABannerFragment on kontent_item_cta_banner {
    system {
      type
    }
    id
    elements {
      cta_heading {
        value
      }
      description {
        value
      }
      eyebrow_text {
        value
      }
      background_image {
        value {
          ...KenticoAssetElementFragment
        }
      }
      button {
        value {
          ...AnchorLinkFragment
          ...ButtonFragment
        }
      }
    }
  }
`
